import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSend, FiStar } = FiIcons;

const ChatInput = ({ input, setInput, handleSend, character, onOpenTarot, isTyping }) => {
  return (
    <motion.footer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 1 }}
      className="fixed bottom-0 inset-x-0 p-4 md:p-6 bg-gradient-to-t from-[#050508] via-[#050508]/95 to-transparent z-40 pointer-events-none safe-pb"
    >
      <AnimatePresence>
        {character?.id === 'tarot-reader' && !isTyping && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            className="absolute bottom-full mb-3 md:mb-5 left-0 w-full flex justify-center pointer-events-auto"
          >
            <button
              onClick={onOpenTarot}
              className="flex items-center space-x-2 px-5 py-2 md:px-6 md:py-2.5 bg-[#0a0a0c]/80 border border-amber-500/40 rounded-full text-amber-400 text-[10px] md:text-xs tracking-widest backdrop-blur-md hover:bg-amber-500/10 hover:border-amber-400 transition-all duration-300 shadow-[0_0_15px_rgba(245,158,11,0.15)] hover:shadow-[0_0_25px_rgba(245,158,11,0.3)] hover:-translate-y-0.5"
            >
              <SafeIcon icon={FiStar} className="animate-pulse" />
              <span>請求塔羅指引</span>
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="max-w-4xl mx-auto pointer-events-auto">
        <div className={`relative flex items-center bg-[#0d0e12]/80 border ${isTyping ? 'border-white/5 opacity-50' : 'border-white/10'} rounded-2xl md:rounded-3xl px-4 py-2.5 md:px-6 md:py-4 focus-within:border-amber-500/40 focus-within:bg-[#111218]/90 transition-all duration-500 shadow-[0_-10px_40px_rgba(0,0,0,0.5)] backdrop-blur-xl group`}>
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSend()}
            placeholder={isTyping ? "等待對方回覆中..." : "寫下你想說的話..."}
            disabled={isTyping}
            className="flex-1 bg-transparent border-none focus:ring-0 text-gray-200 font-light text-sm md:text-base py-1.5 placeholder:text-gray-600 placeholder:tracking-widest placeholder:font-light outline-none caret-amber-500 disabled:bg-transparent"
          />
          <button
            onClick={handleSend}
            disabled={!input.trim() || isTyping}
            className={`ml-3 md:ml-4 p-2.5 md:p-3 rounded-xl md:rounded-2xl transition-all duration-500 flex items-center justify-center ${input.trim() && !isTyping ? 'bg-amber-500 text-black hover:bg-amber-400 hover:shadow-[0_0_20px_rgba(245,158,11,0.4)] scale-100' : 'bg-white/5 text-gray-600 cursor-not-allowed scale-95'}`}
          >
            <SafeIcon icon={FiSend} className="text-sm md:text-base" />
          </button>
        </div>

        <div className="mt-3 md:mt-4 text-center">
          <p className="text-[8px] md:text-[10px] text-gray-500 tracking-wider flex flex-wrap items-center justify-center space-x-2 md:space-x-3 opacity-60 hover:opacity-100 transition-opacity duration-300">
            <Link to="/terms" className="hover:text-amber-400 transition-colors">服務條款</Link>
            <span>·</span>
            <Link to="/privacy" className="hover:text-amber-400 transition-colors">隱私權政策</Link>
            <span className="hidden sm:inline">·</span>
            <span className="w-full sm:w-auto mt-1 sm:mt-0">18+ AI 陪伴，非專業醫療建議</span>
          </p>
        </div>
      </div>
    </motion.footer>
  );
};

export default ChatInput;